import { use } from 'react';
import CartContext from '../cart.context';
const useCartFormFirstName = () => {
    const { firstName, setFirstName, firstNameError, setIsFirstNameInError } = use(CartContext);
    return {
        firstName,
        setFirstName,
        firstNameError,
        setIsFirstNameInError
    };
};
export default useCartFormFirstName;
